<apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [responsive]="chartOptions.responsive"
    [dataLabels]="chartDataLabels"
    [tooltip]="chartOptions.tooltip"
    [colors]="chartOptions.colors"
    [legend]="chartOptions.legend">
</apx-chart>
